module.exports = __webpack_public_path__ + "img/a2.65b83bd6.jpg";